export class ShowcaseItemRequestEntity {
  order?: number
  id?: number
  name?: string | null
  itemId?: number
  itemBranchId?: number
}
